export default {
  vdvibb: {
    hourSlots: [
      { hour: 10, min: 0, duration: 60 },
      { hour: 11, min: 0, duration: 60 },
      // { hour: 11, min: 30, duration: 30 },
      { hour: 12, min: 0, duration: 60 },
      // { hour: 12, min: 30, duration: 30 },
      { hour: 13, min: 0, duration: 60 },
      { hour: 14, min: 0, duration: 30 },
      { hour: 14, min: 30, duration: 30 },
      { hour: 15, min: 0, duration: 30 },
      { hour: 15, min: 30, duration: 30 },
      { hour: 16, min: 0, duration: 60 },
      { hour: 17, min: 0, duration: 60 },
      { hour: 18, min: 0, duration: 0 },
    ],
    availableDays: [1, 3, 4, 5],
  },
  na: {
    hourSlots: [
      { hour: 10, min: 0, duration: 60 },
      { hour: 11, min: 0, duration: 60 },
      // { hour: 11, min: 30, duration: 30 },
      { hour: 12, min: 0, duration: 60 },
      // { hour: 12, min: 30, duration: 30 },
      { hour: 13, min: 0, duration: 60 },
      { hour: 14, min: 0, duration: 30 },
      { hour: 14, min: 30, duration: 30 },
      { hour: 15, min: 0, duration: 30 },
      { hour: 15, min: 30, duration: 30 },
      { hour: 16, min: 0, duration: 60 },
      { hour: 17, min: 0, duration: 60 },
      { hour: 18, min: 0, duration: 0 },
    ],
    availableDays: [1, 3, 4, 5],
  },
  way: {
    hourSlots: [
      { hour: 10, min: 0, duration: 60 },
      { hour: 11, min: 0, duration: 60 },
      // { hour: 11, min: 30, duration: 30 },
      { hour: 12, min: 0, duration: 60 },
      // { hour: 12, min: 30, duration: 30 },
      { hour: 13, min: 0, duration: 60 },
      { hour: 14, min: 0, duration: 30 },
      { hour: 14, min: 30, duration: 30 },
      { hour: 15, min: 0, duration: 30 },
      { hour: 15, min: 30, duration: 30 },
      { hour: 16, min: 0, duration: 60 },
      { hour: 17, min: 0, duration: 60 },
      { hour: 18, min: 0, duration: 0 },
    ],
    availableDays: [1, 3, 4, 5],
  },
  vdvibbrent: {
    hourSlots: [
      { hour: 9, min: 0, duration: 180 },
      { hour: 12, min: 0, duration: 180 },
      { hour: 15, min: 0, duration: 180 },
      { hour: 18, min: 0, duration: 180 },
      { hour: 21, min: 0, duration: 180 },
    ],
    availableDays: [0, 1, 2, 3, 4, 5, 6],
  },
};
